<template v-once>
    <span
        class="is-hidden-mobile ml-2 tag is-light is-outlined has-opacity-third is-family-monospace is-uppercase has-text-weight-bold"
        ><slot></slot
    ></span>
</template>
